import { doc, getDoc } from "firebase/firestore";
import { activate, fetchAndActivate, getValue } from "firebase/remote-config";
import { getFunctions, httpsCallable } from "firebase/functions";
import { firestore, remoteConfig } from "../../../../services/firebase";


import {
  GROWTH_KEYS,
  PREMIUM_ONLY_KEYS,
  ALL_BOOLEAN_KEYS,
  PREMIUM_ONLY_SET,
  resolveFlag,
} from "./feature-keys";


export function getVisibleKeys(planType) {
  const baseKeys = planType === "premium" ? ALL_BOOLEAN_KEYS : GROWTH_KEYS;
  return baseKeys;
}



export function getPremiumOnlyKeys() {
  return PREMIUM_ONLY_KEYS;
}



export async function loadPlanType() {
  const snapshot = await getDoc(
    doc(firestore, "customization", "infos")
  );
  // `.data()` é undefined quando o documento não existe — ler `.planType`
  // direto estourava um TypeError e derrubava a tela inteira.
  return snapshot.exists() ? snapshot.data()?.planType : undefined;
}



export async function loadFeatureFlags(planType) {
  // Buscar valores novos é o ideal, mas não pode derrubar a tela. Se o fetch
  // falhar (rede, timeout, ou o throttle do Remote Config quando várias buscas
  // acontecem em sequência), seguimos com a última configuração já ativada
  // localmente em vez de mostrar erro e todos os toggles desligados.
  try {
    await fetchAndActivate(remoteConfig);
  } catch (error) {
    console.error(
      'Falha ao buscar o Remote Config; usando a última configuração ativada.',
      error
    );
    try {
      await activate(remoteConfig);
    } catch (activateError) {
      console.error('Falha ao ativar a configuração em cache.', activateError);
    }
  }

    const boolState = Object.fromEntries(
      ALL_BOOLEAN_KEYS.map((key) => {
        const isPremiumFeature = PREMIUM_ONLY_SET.has(key);

        if (planType === "growth" && isPremiumFeature) {
          return [key, false];
        }
        // Sem valor publicado, cada chave cai no SEU default — `false` para
        // funcionalidades, `true` para as travas de segurança (ver feature-keys).
        const value = getValue(remoteConfig, key);
        return [
          key,
          resolveFlag(key, {
            isRemote: value.getSource() === "remote",
            value: value.asBoolean(),
          }),
        ];
      })
    );

  // hasScheduleNotifications depende de hasPlanner
  const scheduleNotificationsValue = getValue(remoteConfig, "hasScheduleNotifications");
  const hasScheduleNotifications = scheduleNotificationsValue.getSource() === "remote" && scheduleNotificationsValue.asBoolean();
  boolState.hasScheduleNotifications = boolState.hasPlanner && hasScheduleNotifications;

  return boolState;
}

// SAVE


export async function saveFeatureFlags(booleans) {
  const parameters = Object.fromEntries(
    ALL_BOOLEAN_KEYS.map((key) => [key, booleans[key]])
  );

  parameters.hasScheduleNotifications = booleans.hasScheduleNotifications;

  const updateRemoteConfig = httpsCallable(getFunctions(), "updateRemoteConfig");
  const { data } = await updateRemoteConfig({ parameters });
  return data;
}
